<script>
import RightColumnGroup from "@/components/layout/RightColumnGroup.vue";
import {mapGetters} from "vuex";

export default {
  name: "SocialMediaCampaign",
  components: {RightColumnGroup},
  computed: {
    ...mapGetters('socialMedia', ['itemById']),
    item() {
        return this.itemById(parseInt(this.$route.params.id, 10));
    },
    colSize() {
      if (this.$vuetify.breakpoint.smAndUp) return 8;
      else return 12;
    },
    sidebarObject() {
      return {
        personsInCharge: this.item?.Ansprechpartner,
      }
    },
    apiUrl() {
      return process.env.VUE_APP_API_BASE_URL;
    }
  }
}
</script>

<template>
<v-row v-if="item">
  <v-col cols="12" sm="8">
    <v-row class="new-wrapper px-4 py-4">
      <v-col cols="12">
        <span class="custom-header-text new-font-bold">
          {{ item.Name }}
        </span>
      </v-col>
      <v-col cols="12">
        <p>{{ item.Beschreibung }}</p>
      </v-col>
      <v-col cols="12" v-if="item.Facebook.length > 0">
        <div class="mb-2">
        <b>Facebook (1200 x 630)</b>
        </div>
        <v-slide-group show-arrows>
          <v-slide-item v-for="picture of item.Facebook" :key="picture.id" class="mr-4">
            <v-img :src="apiUrl+picture.url" width="200" contain>
              <v-btn :href="'/api' + picture.url" small color="primary" fab class="download-btn"><v-icon>mdi-download</v-icon></v-btn>
            </v-img>
          </v-slide-item>
        </v-slide-group>
      </v-col>
      <v-col cols="12" v-if="item.Instagram.length > 0">
        <div class="mb-2">
          <b>Instagram (1080 x 1080)</b>
        </div>
        <v-slide-group show-arrows>
          <v-slide-item v-for="picture of item.Instagram" :key="picture.id" class="mr-4" >
              <v-img :src="apiUrl+picture.url" width="200">
                <v-btn tag="a" :download="picture.name" :href="'/api' + picture.url" small color="primary" fab class="download-btn"><v-icon>mdi-download</v-icon></v-btn>
              </v-img>
          </v-slide-item>
        </v-slide-group>
      </v-col>
      <v-col cols="12" v-if="item.Stories.length > 0">
        <div class="mb-2">
          <b>Stories (1200 x 675)</b>
        </div>
        <v-slide-group show-arrows>
          <v-slide-item v-for="picture of item.Stories" :key="picture.id" class="mr-4" >
            <v-img :src="apiUrl+picture.url" width="200">
              <v-btn :href="'/api' + picture.url" small color="primary" fab class="download-btn"><v-icon>mdi-download</v-icon></v-btn>
            </v-img>
          </v-slide-item>
        </v-slide-group>
      </v-col>
      <v-col cols="12" v-if="item.LinkedIn.length > 0">
        <div class="mb-2">
        <b>LinkedIn (1200 x 675)</b>
        </div>
        <v-slide-group show-arrows>
          <v-slide-item v-for="picture of item.LinkedIn" :key="picture.id" class="mr-4" >
            <v-img :src="apiUrl+picture.url" width="200">
              <v-btn tag="a" :download="picture.name" :href="'/api' + picture.url" small color="primary" fab class="download-btn"><v-icon>mdi-download</v-icon></v-btn>
            </v-img>
          </v-slide-item>
        </v-slide-group>
      </v-col>
    </v-row>
  </v-col>
  <v-col cols="12" sm="4" class="contact_container pl-4">
    <RightColumnGroup :content-object="sidebarObject" />
  </v-col>
</v-row>
</template>

<style scoped>
.img-container {
}

.download-btn {
  position: absolute;
  right: 10px;
  bottom: 10px;
  z-index: 1000;
  float: right;
}
</style>
